import { render, staticRenderFns } from "./TrademarkNoteTypeForm.vue?vue&type=template&id=33b4ea3c&"
import script from "./TrademarkNoteTypeForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkNoteTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkNoteTypeForm.vue?vue&type=style&index=0&id=33b4ea3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports